<div id="sandhub-workarea">
  <div class="title-bar-area">
    <div class="title-area">{{title}}</div>
    <!-- <div class="video-icon" (click)="openPopup()"><i class="far fa-video"></i></div> -->
    <app-video-modal *ngIf="showPopup==true" [videoUrl]="videoDetail" (closeVideoPopup)="closeVideoPopup($event)"></app-video-modal>
  </div>
</div>
<div style="background: #fff; overflow-y: scroll; height: 82vh; width: 100% ;">
  <p style="margin:10px"><b>NOTE: THIS PAGE SHOWS ALL APPLICATIONS AVAILABLE ACROSS ISG. SHOULD YOU REQUIRE ACCESS TO A SPECIFIC APPLICATION, PLEASE CONTACT THE ISG SERVICE DESK.</b></p>
  <app-tile-container [tiles]="tiles" [tileTemplate]="tileTemplate" (sortOrderChanged)="orderChange($event)"
                      [size]="'xlarge'" (tilePinnedChange)="addTileToast($event)"></app-tile-container>
</div>

<ng-template #tileTemplate let-model="model">
  <ng-container *ngIf="model.text.includes('ISG Advisor Power-ups Program'); then powertile; else othertiles">
  </ng-container>
  <ng-template #powertile>
    <div class="tile-content">
      <div (click)="activateLink(model)">
        <div class="tile-content-header application-color" title="{{ model.text }}">
          {{ model.text }}
        </div>
        <div class="tile-content-image">
          <img src="../assets/images/workbench/applications/Powerupslogo1.png" alt="The {{model.text}} image" style="width: 220px; height: 98px;" />
        </div>
      </div>

      <div class="row copyclip">

        <div class="col-sm-12">
          <div class="metric-item">
            <div class="tooltiptext" style="width:200px;right:-179px">
              <!--<div class="triangle-right"></div>-->
              <span>
                Copy password to clipboard
              </span>
            </div>
            <i class="fa fa-clipboard" style="font-size:20px;" (click)="copyToClipboard()" aria-hidden="true"></i>
          </div>


        </div>


      </div>

    </div>
  </ng-template>


  <ng-template #othertiles>
    <div (click)="activateLink(model)" class="tile-content">

      <div class="tile-content-header application-color" title="{{ model.text }}">
        {{ model.text }}
      </div>

      <div class="tile-content-image" ng- *ngIf="model.text.includes('Bright Breaks')">
        <!--<img [src]="model.imageUrl" alt="The {{model.text}} image" style="height:50px;" />-->
        <img src="../assets/images/workbench/applications/bright_breaks.png" alt="The {{model.text}} image" style="height:50px;" />
      </div>
      <div class="tile-content-image">
        <img [src]="model.imageUrl" alt="The {{model.text}} image" *ngIf="!model.text.includes('ISG News Center') &&!model.text.includes('Bright Breaks') && !model.text.includes('ISG Academy') && !model.text.includes('Safeguard Global')  && !model.text.includes('ISG Advisor Power-ups Program')" />
      </div>
      <div class="tile-content-image" ng- *ngIf="model.text.includes('ISG Academy')">
        <img src="../assets/images/workbench/applications/IsgAcademy.png" alt="The {{model.text}} image" style="height:58px; max-width:210px;" />
      </div>
      <div class="tile-content-image" ng- *ngIf="model.text.includes('ISG News Center')">
        <img src="../assets/images/workbench/applications/DynamicSignal.svg" alt="The {{model.text}} image" style="height:95px; max-width:210px;" />
      </div>
      <div class="tile-content-image" ng- *ngIf="model.text.includes('Safeguard Global')">
        <img src="../assets/images/workbench/applications/SafeguardGlobal.png" alt="The {{model.text}} image" style="height:58px; max-width:210px;" />
      </div>
    </div>
  </ng-template>

</ng-template>

